import React from 'react';
import { Button, Modal } from 'antd';

export function OpenAiModal({ onOk = () => null, onCancel = () => null }) {
  return (
    <Modal
      className="vetsmith-modal"
      closable={false}
      centered
      visible
      width={450}
      okText="Ok"
      onCancel={onCancel}
      onOk={onOk}
      footer={[
        <Button onClick={onCancel}>Cancel</Button>,
        <Button type="primary" onClick={onOk} data-cy="vetsmith-modal__button-ok">
          Continue
        </Button>,
      ]}
    >
      <div className="job-request-modal__container">
        In order for you to complete your application for this job, you need to take a brief technical assessment to evaluate your technical fit for the role. Click “Continue”
      </div>
    </Modal>
  );
}
